import {ElementRef, inject } from '@angular/core';

const maxId = Number.MAX_SAFE_INTEGER - 1;

// function to help create unique ids for html elements;
// this is kinda based off how angular cdk/material components work
export function generateHtmlId(prefix: string): () => string {
  const nextInt = generateNextInt();
  return () => {
    return combineHtmlIds(prefix, nextInt());
  };
}

export function generateNextInt(): () => number {
  let nextId = 0;
  return () => {
    nextId++;
    if (nextId > maxId) {
      nextId = 0;
    }

    return nextId;
  };
}

export function combineHtmlIds(...htmlIds: Array<string | number>): string {
  return htmlIds.join('-');
}


// special identifier for stuff providedIn: 'root',
// which can't inject an ElementRef
const rootTagName = `ap-application-root`;

const _nextIntByTagName = new Map<string, () => number>();
function _nextInt(tagName: string): number {
  const getNextInt = _nextIntByTagName.get(tagName);
  if (getNextInt) {
    return getNextInt();
  }
  const _getNextInt = generateNextInt();
  _nextIntByTagName.set(tagName, _getNextInt);
  return _getNextInt();
}
function _nextHtmlId(tagName: string): string {
  return combineHtmlIds(tagName, _nextInt(tagName));
}

export function nextHtmlId(element: HTMLElement): string {
  // this could be localName or tagName
  return _nextHtmlId(element.localName);
}

export function injectNextHtmlId(): [element: HTMLElement | undefined, uniqueId: string] {
  const element = inject<ElementRef<HTMLElement>>(ElementRef<HTMLElement>, {
    optional: true,
  })?.nativeElement;
  if (!element) {
    return [
      element,
      _nextHtmlId(rootTagName),
    ];
  }

  return [
    element,
    nextHtmlId(element),
  ];
}
